var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddSubStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_2638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63 20.17C4.45 20.17 4.3 20.11 4.18 19.99C4.06 19.87 4 19.72 4 19.54C4 19.36 4.06 19.21 4.18 19.09C4.3 18.97 4.45 18.91 4.63 18.91H21.9C22.08 18.91 22.23 18.97 22.35 19.09C22.47 19.21 22.53 19.36 22.53 19.54C22.53 19.72 22.47 19.87 22.35 19.99C22.23 20.11 22.08 20.17 21.9 20.17H4.63ZM6.1 17.64C5.76 17.64 5.47 17.51 5.22 17.26C4.97 17.01 4.84 16.71 4.84 16.38V6.26C4.84 5.92 4.97 5.63 5.22 5.38C5.47 5.13 5.77 5 6.1 5H20.42C20.76 5 21.05 5.13 21.3 5.38C21.55 5.63 21.68 5.93 21.68 6.26V16.37C21.68 16.71 21.55 17 21.3 17.25C21.05 17.5 20.75 17.63 20.42 17.63H6.11L6.1 17.64Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.23 11.64V11.52C17.23 11.1224 16.9077 10.8 16.51 10.8H10.03C9.63237 10.8 9.31001 11.1224 9.31001 11.52V11.64C9.31001 12.0377 9.63237 12.36 10.03 12.36H16.51C16.9077 12.36 17.23 12.0377 17.23 11.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.33 7.62012H13.21C12.8123 7.62012 12.49 7.94247 12.49 8.34012V14.8201C12.49 15.2178 12.8123 15.5401 13.21 15.5401H13.33C13.7276 15.5401 14.05 15.2178 14.05 14.8201V8.34012C14.05 7.94247 13.7276 7.62012 13.33 7.62012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_2638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.54,
    height: 15.17,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddSubStep);
export default __webpack_public_path__ + "static/media/iconAddSubStep.ae9e1d02.svg";
export { ForwardRef as ReactComponent };